export const EXPO_SENTRY_DSN =
	"https://8efae405e85b48c5acb8d7b332fdf26f@o4504732282126336.ingest.sentry.io/4504732284616704";

export const NEXT_SENTRY_DSN =
	"https://904d611d184811d31f2aa99e091f3d99@o4504732282126336.ingest.sentry.io/4506377791340544";
